export const SKILL_API_BASE = '/backend/common/api/v2';
export const SKILL_AI_STATISTICS_API_BASE = '/backend/admin/skill-learning/ai';

export const SKILL_SPECIALIZATIONS_API = {
  BASE: `${SKILL_API_BASE}/skill-specializations`,
  AVAILABLE: `${SKILL_API_BASE}/skill-specializations/available`,
  BY_ID: (id: string) => `${SKILL_API_BASE}/skill-specializations/${id}`,
  FILL_TASK: (id: string) => `${SKILL_API_BASE}/skill-specializations/${id}/fill-task`,
  CURATORS: (id: string) => `${SKILL_API_BASE}/skill-specializations/${id}/curators`,
  CURATOR_BY_ID: (id: string, curatorId: string) =>
    `${SKILL_API_BASE}/skill-specializations/${id}/curators/${curatorId}`,
  THEORY_LEVEL: (id: string) => `${SKILL_API_BASE}/skill-specializations/${id}/levels/1/theory`,
  THEORY_DIRECTIONS_PROMPT: (id: string) =>
    `${SKILL_API_BASE}/skill-specializations/${id}/levels/1/directions-prompt`,
  PRACTICE_LEVEL_2: (id: string) => `${SKILL_API_BASE}/skill-specializations/${id}/levels/2/practice`,
  PRACTICE_LEVEL_3: (id: string) => `${SKILL_API_BASE}/skill-specializations/${id}/levels/3/practice`,
  LEVEL_DOCUMENT: (id: string, level: number) =>
    `${SKILL_API_BASE}/skill-specializations/${id}/levels/${level}/document`,
  BY_GROUP: (groupId: string) => `${SKILL_API_BASE}/skill-specializations/by-group/${groupId}`,
  MY_CURATED: `${SKILL_API_BASE}/skill-specializations/my-curated`,
};

export const SKILL_PROGRESS_API = {
  DEPARTMENTS: `${SKILL_API_BASE}/skill-progress/departments`,
  BY_SPECIALIZATION: (specializationId: string) =>
    `${SKILL_API_BASE}/skill-progress/${specializationId}`,
  TOPIC_TOGGLE: (specializationId: string, topicIndex: number) =>
    `${SKILL_API_BASE}/skill-progress/${specializationId}/topics/${topicIndex}/toggle`,
  BY_USER: (specializationId: string, userId: string) =>
    `${SKILL_API_BASE}/skill-progress/${specializationId}/user/${userId}`,
  WEIGHT_SUM: `${SKILL_API_BASE}/skill-progress/weight-sum`,
};

export const SKILL_CHAT_API = {
  MESSAGE: (specializationId: string) =>
    `${SKILL_API_BASE}/skill-chat/${specializationId}/message`,
  HISTORY: (specializationId: string) =>
    `${SKILL_API_BASE}/skill-chat/${specializationId}/history`,
  CHAT: (specializationId: string) =>
    `${SKILL_API_BASE}/skill-chat/${specializationId}`,
};

export const SKILL_TESTS_API = {
  GENERATE: (specializationId: string) =>
    `${SKILL_API_BASE}/skill-tests/${specializationId}/generate`,
  SUBMIT: (specializationId: string) =>
    `${SKILL_API_BASE}/skill-tests/${specializationId}/submit`,
  COOLDOWN: (specializationId: string) =>
    `${SKILL_API_BASE}/skill-tests/${specializationId}/cooldown`,
};

export const SKILL_SETTINGS_API = {
  GENERAL: `${SKILL_API_BASE}/skill-learning/settings`,
};

export const SKILL_AI_STATISTICS_API = {
  SUMMARY: `${SKILL_AI_STATISTICS_API_BASE}/statistics/summary`,
  TIMESERIES: `${SKILL_AI_STATISTICS_API_BASE}/statistics/timeseries`,
  TOP_USERS: `${SKILL_AI_STATISTICS_API_BASE}/statistics/top-users`,
  TOP_SPECIALIZATIONS: `${SKILL_AI_STATISTICS_API_BASE}/statistics/top-specializations`,
  LOGS: `${SKILL_AI_STATISTICS_API_BASE}/logs`,
  BUDGET_STATUS: `${SKILL_AI_STATISTICS_API_BASE}/budget-status`,
  STANDARD_QUESTIONS_STATISTICS: `${SKILL_AI_STATISTICS_API_BASE}/standard-questions/statistics`,
};

export const SKILL_PRACTICE_API = {
  START: (specializationId: string, level: number) =>
    `${SKILL_API_BASE}/skill-practice/${specializationId}/levels/${level}/start`,
  TASK: (specializationId: string, level: number) =>
    `${SKILL_API_BASE}/skill-practice/${specializationId}/levels/${level}/task`,
};

export const SKILL_REQUESTS_API = {
  BASE: `${SKILL_API_BASE}/skill-requests`,
  BY_ID: (id: string) => `${SKILL_API_BASE}/skill-requests/${id}`,
  MY: `${SKILL_API_BASE}/skill-requests/my`,
  APPROVE: (id: string) => `${SKILL_API_BASE}/skill-requests/${id}/approve`,
  REJECT: (id: string) => `${SKILL_API_BASE}/skill-requests/${id}/reject`,
};

export const SKILL_GROUPS_API = {
  BASE: `${SKILL_API_BASE}/skill-groups`,
  BY_ID: (groupId: string) => `${SKILL_API_BASE}/skill-groups/${groupId}`,
  AVAILABLE_CURATORS: (groupId: string, specializationId: string) =>
    `${SKILL_API_BASE}/skill-groups/${groupId}/available-curators?specializationId=${specializationId}`,
  ALL_CURATORS: (groupId: string) =>
    `${SKILL_API_BASE}/skill-groups/${groupId}/available-curators`,
};



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/constants/skill-api.constants.ts